import SuspenseWrapper from '@monofe/ui-common/misc/SuspenseWrapper';
import { injectLog } from '@monofe/util';
import type { ComponentType, LazyExoticComponent } from 'react';
import loader from '../common/loader';
import type { ITourSelectIndexProps, ITourSelectMainProps } from './interface';
import { ITourSelectType } from './interface';

const MainViewList = loader(() => import('./list'));
const MainViewGrid = loader(() => import('./grid'));

function IndexView(props: ITourSelectIndexProps): JSX.Element {
    const log = injectLog();

    let Renderer:
        | ComponentType<ITourSelectMainProps>
        | LazyExoticComponent<(props: ITourSelectMainProps) => JSX.Element>
        | null = null;

    switch (props.type) {
        case ITourSelectType.List:
            Renderer = MainViewList;
            break;

        case ITourSelectType.GridTile:
            Renderer = MainViewGrid;
            break;

        case ITourSelectType.GridFeatured:
            log.error('Unsupported Tour Selection Type grid-featured, falling back to grid type');
            Renderer = MainViewGrid;
            break;

        default:
            throw Error(`Unsupported tour type: ${props.type}`);
    }

    return <SuspenseWrapper fallback={null}>{<Renderer {...props} />}</SuspenseWrapper>;
}

export default IndexView;
